import { CommonModule } from '@angular/common';
import { Component, NgModule } from '@angular/core';
import { DxDrawerModule } from 'devextreme-angular';
import { DxScrollViewModule } from 'devextreme-angular';
import { DxToolbarModule } from 'devextreme-angular';
import { HeaderModule } from 'src/app/shared/components/layout';
@Component({
    selector: 'app-top-navigation-toolbar',
    templateUrl: './top-navigation-toolbar.component.html',
    styleUrls: ['./top-navigation-toolbar.component.scss'],
})
export class TopNavigationToolbarComponent {}

@NgModule({
    imports: [DxDrawerModule, HeaderModule, DxToolbarModule, DxScrollViewModule, CommonModule],
    exports: [TopNavigationToolbarComponent],
    declarations: [TopNavigationToolbarComponent],
})
export class TopNavigationToolbarModule {}
